import { all, put, takeLatest, call, select } from "redux-saga/effects";
import { normalize, schema } from "normalizr";
import cloneDeep from "lodash/fp/cloneDeep";

import { getErrorMessage } from "../../../../utils/sagasErrorHandler";
import { sharedHistory } from "../../../../routes/sharedHistory";
import { ROUTES_MAP } from "../../../../routes/constants";
import { modulesInitialFilters } from "../../../../constants/modulesInitialFilters";

import {
    createConfig,
    createConfigError,
    createConfigSuccess,
    editConfig,
    editConfigError,
    editConfigSuccess,
    getConfigByID,
    getConfigByIDError,
    getConfigByIDSuccess,
    getNormalizers,
    getNormalizersError,
    getNormalizersSuccess
} from "./actions";
import { createConfigRequest, editConfigRequest, getConfigRequest, getNormalizersRequest } from "./api";
import { normalizersSelector } from "./selectors";
import {toast} from "react-toastify";

const normalizersSchema = new schema.Entity("normalizers", {}, { idAttribute: "code" });
const normalizersListSchema = new schema.Array(normalizersSchema);

function* handleGetNormalizers({ payload }){
    try {
        const data = yield getNormalizersRequest(payload);
        yield put(getNormalizersSuccess(data));

        const { normalizersList } = yield select(normalizersSelector);
        if(!normalizersList.length){
            const { normalizers } = yield call(getNormalizersRequest);
            const { result, entities } = normalize(normalizers, normalizersListSchema);

            yield put(getNormalizersSuccess({
                isLoadingReceivers: false,
                normalizersList: entities.normalizers,
                codes: result
            }));
        }
    } catch (error) {
        yield put(getNormalizersError());
        getErrorMessage(error);
    }
}

function* handleGetConfigByID({ payload }){
    try {
        const { id, ...retsConfigData } = payload;

        const data = yield getConfigRequest(id);
        const initialConfig = { ...data, ...retsConfigData };

        yield put(getConfigByIDSuccess(initialConfig));
    } catch (error) {
        yield put(getConfigByIDError());
        getErrorMessage(error);
    }
}

function* handleCreateConfig({ payload }){
    try {
        const initialObject = cloneDeep(payload);

        initialObject.worker.branch_code = initialObject.branch_code;
        initialObject.worker.receiver_code = initialObject.receiver_code;
        initialObject.worker.initial_source_code = initialObject.initial_source_code;

        yield createConfigRequest(payload);
        yield put(createConfigSuccess());

        sharedHistory.push(ROUTES_MAP.configManager.createURL(modulesInitialFilters.configManager));
        yield call(toast.success, "The config has been successfully created");
    } catch (error) {
        getErrorMessage(error?.response?.data);
        yield put(createConfigError());
    }
}

function* handleEditConfig({ payload }){
    try {
        const { initialConfig, id } = payload;
        const data = cloneDeep(initialConfig);
        yield call(editConfigRequest, { id, initialConfig: data });
        yield put(editConfigSuccess());
        sharedHistory.push(ROUTES_MAP.configManager.createURL(modulesInitialFilters.configManager));
        yield call(toast.success, `The config with id - ${id} has been successfully updated`);
    } catch (error) {
        getErrorMessage(error?.response?.data);
        yield put(editConfigError());
    }
}

export function* editCreateConfigSagas() {
    yield all([
        yield takeLatest(getNormalizers, handleGetNormalizers),
        yield takeLatest(getConfigByID, handleGetConfigByID),
        yield takeLatest(createConfig, handleCreateConfig),
        yield takeLatest(editConfig, handleEditConfig)
    ]);
}
